import React, { useState } from 'react';
import {
  ShoppingCart, MapPin, Info,
  Beef, Flame, Star, ChefHat, Sandwich, Wheat, Salad
} from 'lucide-react';
import ASZFModal from '../components/ASZFModal';
import '../styles/OrderPage.css';

// ── Lepény ikon map ──────────────────────────────────────────
const LEPENY_ICONS = {
  l1:  { icon: Wheat,    color: '#C9A84C' }, // Sajtos         → búza/tészta alap
  l3:  { icon: Salad,    color: '#C0392B' }, // Paradicsomos   → zöldséges/mediterrán
  l5:  { icon: Sandwich, color: '#D4816F' }, // Sajtos-sonkás  → szendvics párosítás
  l6:  { icon: Beef,     color: '#8B3A2A' }, // Kolbászos      → húsos
  l8:  { icon: Flame,    color: '#E74C3C' }, // Chilis marha   → csípős láng
  l9:  { icon: Star,     color: '#C9872A' }, // Extra          → minden jóval
  l10: { icon: ChefHat,  color: '#4A7C6B' }, // Görög csirkés  → séf/különleges
};

const LepenyIcon = ({ lepenyId, size = 28, strokeWidth = 1.5 }) => {
  const cfg = LEPENY_ICONS[lepenyId];
  if (!cfg) return <Wheat size={size} strokeWidth={strokeWidth} color="#8B6F47" />;
  const Icon = cfg.icon;
  return <Icon size={size} strokeWidth={strokeWidth} color={cfg.color} />;
};

// ────────────────────────────────────────────────────────────

const LepenyPage = ({
  lepenyTypes,
  cartItems,
  orderForm,
  setOrderForm,
  addLepenyToCart,
  updateQuantity,
  handleSubmitOrder,
  totalPrice
}) => {
  const [showASZFModal, setShowASZFModal] = useState(false);

  return (
    <div className="order-page">
      <div className="order-header">
        <h1>Lepény Rendelés</h1>
        <p>Frissen sült eredeti kecskeméti lepények</p>
      </div>

      <div className="order-layout">

        {/* ── LEPÉNY KATALÓGUS ── */}
        <div className="cake-catalog">
          <div className="catalog-grid">
            {lepenyTypes && lepenyTypes.map(lepeny => (
              <div key={lepeny.id} className="cake-card">
                <div className="cake-icon-wrap">
                  <LepenyIcon lepenyId={lepeny.id} size={28} />
                </div>
                <h3>{lepeny.name}</h3>
                <p className="cake-description">{lepeny.description}</p>
                <div className="cake-details">
                  <span className="base-price">{lepeny.price.toLocaleString('hu-HU')} Ft</span>
                </div>
                <button
                  className="add-to-cart-btn"
                  onClick={() => addLepenyToCart(lepeny)}
                >
                  <ShoppingCart size={16} strokeWidth={1.5} /> Kosárba
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* ── KOSÁR & ŰRLAP ── */}
        <div className="order-sidebar">
          <div className="cart-section" id="cart-section">
            <h2>Kosár</h2>
            {cartItems.length === 0 ? (
              <p className="empty-cart">A kosár üres</p>
            ) : (
              <>
                {cartItems.map(item => (
                  <div key={item.id} className="cart-item">
                    <div className="cart-item-info">
                      <div className="cart-icon-wrap">
                        <LepenyIcon lepenyId={item.id} size={20} />
                      </div>
                      <div>
                        <h4>{item.name}</h4>
                        <p className="cart-price">{item.price.toLocaleString('hu-HU')} Ft</p>
                      </div>
                    </div>
                    <div className="quantity-controls">
                      <button onClick={() => updateQuantity(item.id, item.quantity - 1)}>−</button>
                      <span>{item.quantity}</span>
                      <button onClick={() => updateQuantity(item.id, item.quantity + 1)}>+</button>
                    </div>
                  </div>
                ))}
                <div className="cart-total">
                  <span>Összesen:</span>
                  <span className="total-price">{totalPrice.toLocaleString('hu-HU')} Ft</span>
                </div>
              </>
            )}
          </div>

          {cartItems.length > 0 && (
            <form className="order-form" onSubmit={handleSubmitOrder}>
              <h3>Rendelési Adatok</h3>

              <div className="form-group">
                <label>Név *</label>
                <input type="text" required value={orderForm.name}
                  onChange={e => setOrderForm({...orderForm, name: e.target.value})}
                  placeholder="Kovács János" />
              </div>

              <div className="form-group">
                <label>Telefon *</label>
                <input type="tel" required value={orderForm.phone}
                  onChange={e => setOrderForm({...orderForm, phone: e.target.value})}
                  placeholder="+36 30 123 4567" />
              </div>

              <div className="form-group">
                <label>Email *</label>
                <input type="email" required value={orderForm.email}
                  onChange={e => setOrderForm({...orderForm, email: e.target.value})}
                  placeholder="pelda@email.hu" />
              </div>

              <div className="form-group">
                <label>Átvétel Dátuma és Időpontja *</label>
                <input
                  type="datetime-local"
                  required
                  value={orderForm.pickupDate}
                  onChange={e => {
                    const selectedValue = e.target.value;
                    if (!selectedValue) { setOrderForm({...orderForm, pickupDate: ''}); return; }

                    const selectedDate = new Date(selectedValue);
                    const day = selectedDate.getDay();
                    const hours = selectedDate.getHours();
                    const minutes = selectedDate.getMinutes();
                    const time = hours * 60 + minutes;

                    let isValid = false;
                    let defaultTime = '12:00';
                    let errorMessage = '';

                    if (day >= 1 && day <= 4) {
                      if ((time >= 420 && time <= 600) || (time >= 720 && time <= 1080)) isValid = true;
                      errorMessage = 'Hétfőtől csütörtökig 07:00–10:00 és 12:00–18:00 között vagyunk nyitva!';
                    } else if (day === 5) {
                      if ((time >= 420 && time <= 600) || (time >= 720 && time <= 1140)) isValid = true;
                      errorMessage = 'Pénteken 07:00–10:00 és 12:00–19:00 között vagyunk nyitva!';
                    } else if (day === 6) {
                      if (time >= 600 && time <= 1140) isValid = true;
                      defaultTime = '10:00';
                      errorMessage = 'Szombaton 10:00–19:00 között vagyunk nyitva!';
                    } else if (day === 0) {
                      if (time >= 600 && time <= 1080) isValid = true;
                      defaultTime = '10:00';
                      errorMessage = 'Vasárnap 10:00–18:00 között vagyunk nyitva!';
                    }

                    if (!isValid) {
                      alert(errorMessage);
                      setOrderForm({...orderForm, pickupDate: selectedValue.split('T')[0] + 'T' + defaultTime});
                    } else {
                      setOrderForm({...orderForm, pickupDate: selectedValue});
                    }
                  }}
                  min={(() => {
                    const now = new Date();
                    return `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}T${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}`;
                  })()}
                />

                <div className="pickup-note">
                  <Info size={15} strokeWidth={1.5} />
                  <span>
                    A lepényeket <strong>akár aznapi átvétellel</strong> is megrendelheti!<br />
                    <strong>H–Cs:</strong> 7–10 & 12–18 · <strong>P:</strong> 7–10 & 12–19 · <strong>Szo:</strong> 10–19 · <strong>V:</strong> 10–18
                  </span>
                </div>
                <div className="pickup-address">
                  <MapPin size={15} strokeWidth={1.5} />
                  <span><strong>Átvétel:</strong> 6724 Szeged, Kossuth Lajos sgt. 45.</span>
                </div>
              </div>

              <div className="form-group">
                <label>Megjegyzés</label>
                <textarea
                  value={orderForm.notes}
                  onChange={e => setOrderForm({...orderForm, notes: e.target.value})}
                  placeholder="Különleges kérések, stb."
                  rows="3"
                />
              </div>

              <div className="form-group aszf-group">
                <label className="aszf-checkbox">
                  <input type="checkbox" required className="aszf-input" />
                  <span className="aszf-text">
                    Elfogadom az{' '}
                    <a href="#" onClick={e => { e.preventDefault(); setShowASZFModal(true); }}>
                      Általános Szerződési Feltételeket
                    </a>. *
                  </span>
                </label>
              </div>

              <button type="submit" className="submit-order-btn">
                Rendelés Leadása
              </button>
            </form>
          )}
        </div>
      </div>

      {cartItems.length > 0 && (
        <div className="mobile-cart-float"
          onClick={() => document.getElementById('cart-section')?.scrollIntoView({ behavior: 'smooth' })}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <ShoppingCart size={20} strokeWidth={1.5} />
            <span className="float-badge">{cartItems.reduce((s, i) => s + i.quantity, 0)} db</span>
          </div>
          <span>Ugrás a pénztárhoz ({totalPrice.toLocaleString('hu-HU')} Ft)</span>
        </div>
      )}

      <ASZFModal isOpen={showASZFModal} onClose={() => setShowASZFModal(false)} />
    </div>
  );
};

export default LepenyPage;